import { Component, ContentChild, EventEmitter, Input, OnInit, Output, SimpleChange, SimpleChanges, TemplateRef } from '@angular/core';
import { TableTotalOption } from './hd-current-table.service';
import { InputBoolean } from 'ng-zorro-antd/core';
import { Page } from '../model/common-type';

@Component({
  selector: 'hd-current-table',
  templateUrl: './hd-current-table.component.html',
  styleUrls: ['./hd-current-table.component.less']
})
export class HdCurrentTableComponent implements OnInit {
  @Input() tableData: Page<any>;
  @Input() scroll: { [key: string]: string } = { x: '1px' };
  @Input() @InputBoolean() showSelected: boolean = false;
  @Input() selectField: string = 'billNumber';
  // 合计区域
  @Input() @InputBoolean() showTableTotal: boolean = false;
  @Input() tableTotalOption: Array<TableTotalOption>;
  @Output() selectEvent = new EventEmitter();
  @Output() tableSearchEvent = new EventEmitter();
  @ContentChild("tableHead", { static: false }) tableHead: TemplateRef<any>;
  @ContentChild("tableBody", { static: false }) tableBody: TemplateRef<any>;
  @ContentChild("tableTotal", { static: false }) tableTotal: TemplateRef<any>;

  @Input() tableLoading: boolean = false;
  // 表格分页参数
  @Input() tablePageIndex: number = 1;
  @Input() tablePageSize: number = 10;
  @Output() tablePageIndexChange = new EventEmitter<any>();
  @Output() tablePageSizeChange = new EventEmitter<any>();
  // 表格勾选参数
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  listOfDisplayData = [];
  listOfAllData = [];
  listOfSelection: Array<any> | TemplateRef<void>;
  mapOfCheckedId: { [key: string]: boolean } = {};
  mapOfCheckList: { [key: string]: any } = {};

  tableTotalOptionList = [];

  constructor() { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChange) {
    // 数据改变时，重置勾选状态
    if (changes && changes['tableData'] && changes['tableData']['currentValue'] && changes['tableData']['previousValue']) {
      if(changes['tableData']['currentValue']['pageSize'] !== changes['tableData']['previousValue']['pageSize']
      || changes['tableData']['currentValue']['pageNumber'] !== changes['tableData']['previousValue']['pageNumber']){
        return;
      }
      this.resetStatus();
    }
  }

  // 表格勾选逻辑
  currentPageDataChange($event: any): void {
    this.listOfDisplayData = $event;
    this.refreshStatus();
    this.resetStatus();
  }

  search(reset: boolean) {
    if(reset){
      this.tablePageSizeChange.emit(this.tablePageSize);
    }else{
      this.tablePageIndexChange.emit(this.tablePageIndex);
    }
    // 触发父组件查询事件
    this.tableSearchEvent.emit(reset);
  }

  resetStatus() {
    this.isAllDisplayDataChecked = false;
    this.isIndeterminate = false;
    this.mapOfCheckedId = {};
    this.mapOfCheckList = {};
    this.selectEvent.emit([]);
  }

  refreshStatus(event: boolean = false, data: any = null): void {
    if (event && data) {
      !this.mapOfCheckList[data[this.selectField]] && (this.mapOfCheckList[data[this.selectField]] = data);
    } else if (!event && data) {
      this.mapOfCheckList[data[this.selectField]] && delete this.mapOfCheckList[data[this.selectField]];
    }
    this.isAllDisplayDataChecked = this.listOfDisplayData.every(item => this.mapOfCheckedId[item[this.selectField]]);
    this.isIndeterminate =
      this.listOfDisplayData.some(item => this.mapOfCheckedId[item[this.selectField]]) && !this.isAllDisplayDataChecked;
    // 触发select事件
    if (this.selectEvent) {
      const selectedList: Array<any> = Object.values(this.mapOfCheckList);
      this.selectEvent.emit(selectedList);
    }
    // 如果数据为空，则清空勾选标识
    if (this.tableData.content.length === 0) {
      this.isAllDisplayDataChecked = false;
    }
  }

  checkAll(value: boolean): void {
    this.listOfDisplayData.forEach(item => {
      if (value) {
        !this.mapOfCheckList[item[this.selectField]] && (this.mapOfCheckList[item[this.selectField]] = item);
      } else {
        this.mapOfCheckList[item[this.selectField]] && delete this.mapOfCheckList[item[this.selectField]];
      }

      this.mapOfCheckedId[item[this.selectField]] = value
    });
    this.refreshStatus();
  }
}
